import { ResponsiveSize } from 'src/components/Globals/Globals';
import styled from 'styled-components';

export const H1 = styled.h1`
  font-weight: 400;
  font-size: 1.5rem;

  @media (min-width: ${ResponsiveSize.tablet}) {
    font-size: 2rem;
  }
`;

export const H2 = styled.h2`
  font-weight: 300;
  font-size: 1.2rem;

  @media (min-width: ${ResponsiveSize.tablet}) {
    font-size: 1.5rem;
  }
`;

export const H3 = styled.h3`
  font-weight: 600;
  font-size: 1rem;

  @media (min-width: ${ResponsiveSize.tablet}) {
    font-size: 1.2rem;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Elements/Elements.tsx